import { Card, CardBody, CardHeader, Heading, Box } from '@chakra-ui/react'
import { PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts'

interface PieChartProps {
  title: string
  labels: string[]
  data: number[]
  colors?: string[]
  isLoading?: boolean
}

const defaultColors = [
  '#3182CE',
  '#38A169',
  '#D69E2E',
  '#E53E3E',
  '#805AD5',
  '#DD6B20',
  '#319795',
  '#00B5D8',
]

export function PieChart({
  title,
  labels,
  data,
  colors = defaultColors,
  isLoading = false,
}: PieChartProps) {
  const chartData = labels.map((label, index) => ({
    name: label,
    value: data[index] || 0,
  }))

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Heading size="md">{title}</Heading>
        </CardHeader>
        <CardBody>
          <Box h="200px" display="flex" alignItems="center" justifyContent="center">
            Loading...
          </Box>
        </CardBody>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <Heading size="md">{title}</Heading>
      </CardHeader>
      <CardBody>
        <Box h="200px">
          <ResponsiveContainer width="100%" height="100%">
            <RechartsPieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                outerRadius={60}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </RechartsPieChart>
          </ResponsiveContainer>
        </Box>
      </CardBody>
    </Card>
  )
}

